import { apiWrapper } from './apiWrapper';
import type {
  FinancialAccountWithBalances,
  CreatePayoutAccountRequest,
  PayoutAccount,
} from '../../models/FinancialAccount';

const BASE_URL = '/financial-accounts';

export const financialAccountApi = {
  /**
   * Get all financial accounts
   */
  async getAccounts(params?: {
    account_type?: string;
    status?: string;
    include_balances?: boolean;
  }): Promise<FinancialAccountWithBalances[]> {
    const queryParams = new URLSearchParams();
    if (params?.account_type) queryParams.append('account_type', params.account_type);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.include_balances) queryParams.append('include_balances', 'true');

    const url = `${BASE_URL}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return apiWrapper(url);
  },

  /**
   * Get a specific financial account by ID
   */
  async getAccount(accountId: number): Promise<FinancialAccountWithBalances> {
    return apiWrapper(`${BASE_URL}/${accountId}`);
  },

  /**
   * Create a new payout account for a financial account
   */
  async createPayoutAccount(
    accountId: number,
    data: CreatePayoutAccountRequest
  ): Promise<PayoutAccount> {
    return apiWrapper(`${BASE_URL}/${accountId}/payout-accounts`, {
      method: 'POST',
      body: data,
    });
  },

  /**
   * Get all payout accounts for a financial account
   */
  async getPayoutAccounts(accountId: number): Promise<PayoutAccount[]> {
    return apiWrapper(`${BASE_URL}/${accountId}/payout-accounts`);
  },

  /**
   * Update a financial account's status
   */
  async updateAccount(
    accountId: number,
    data: { status: string }
  ): Promise<FinancialAccountWithBalances> {
    return apiWrapper(`${BASE_URL}/${accountId}`, {
      method: 'PUT',
      body: data,
    });
  },

  /**
   * Release funds from available balance to pending_release
   */
  async releaseFunds(
    accountId: number,
    amount: number,
    options?: {
      batch_id?: number | null;
      new_batch_name?: string;
    }
  ): Promise<{ success: boolean; message: string; batch_id: number; batch_number: string }> {
    return apiWrapper(`${BASE_URL}/${accountId}/release-funds`, {
      method: 'POST',
      body: {
        amount,
        batch_id: options?.batch_id,
        new_batch_name: options?.new_batch_name,
      },
    });
  },
};
